exports = module.exports = require("/home/kwok/projects/brewplanner/brewplanner-ui/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".bp-grid-item-withfilter{overflow:auto;padding:20px}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Commons/GridItem/GridItemWithFilter.scss
 ** module id = 253
 ** module chunks = 0
 **/